import axios from 'axios';

let authenticated = false;

export async function authenticate() {
  const {data} = await axios.get(`${process.env.AUTH_URL}/api/v1/auth`, {withCredentials: true});
  return data;
}

export async function isAuthenticated() {
  if (!authenticated) {
    authenticated = await authenticate();
  }
  return authenticated;
}